module.exports = __webpack_public_path__ + "arrow-back.svg?5eb6b6db9cc427e7506f7d77a24832d4";